import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import { Label } from '@mlc/web-ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const LoadMoreContainer = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: 24px;
	margin-top: 15px;
`;

export const LoadMoreButton = styled.button`
	align-items: center;
	background: ${palette.mlcWhite};
	border: 0;
	display: flex;
	height: 44px;
	padding: 0 20px;

	&:focus,
	&:hover {
		cursor: pointer;
	}
`;

export const LoadMoreLabel = styled(Label)`
	color: ${palette.mlcTextLink};
	margin: 0;

	${LoadMoreButton}:hover & {
		text-decoration: underline;
	}
`;

export const LoadMoreIcon = styled(FontAwesomeIcon)`
	color: ${palette.mlcTextLink};
	margin-bottom: 2px;
	margin-left: 15px;
`;
